import styles from './Calculatorresultskeyitem.module.css'

export type CalculatorresultskeyitemProps = {
  title: string
  highscore: string
  mediumscore: string
  lowscore: string
}

export const PhnxCalculatorresultskeyitem: React.FC<CalculatorresultskeyitemProps> = ({
  lowscore,
  mediumscore,
  title,
  highscore,
}) => {
  return (
    <div className={styles['calculatorresultskeyitem']}>
      <div className={styles['title']}>{title}</div>
      <div className={styles['items']}>
        <div className={styles['itemdetails']}>
          <div className={styles['itemhigh']}>HIGH SCORE</div>
          <div className={styles['description']}>{highscore}</div>
        </div>
        <div className={styles['itemdetails']}>
          <div className={styles['itemmedium']}>MEDIUM SCORE</div>
          <div className={styles['description']}>{mediumscore}</div>
        </div>
        <div className={styles['itemdetails']}>
          <div className={styles['itemlow']}>LOW SCORE</div>
          <div className={styles['description']}>{lowscore}</div>
        </div>
      </div>
    </div>
  )
}
